module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="mdl_multisizeinfo">\n    <button type="button" class="mdl_multisizeinfo__close js_close_multisizeinfo"></button>\n    <div class="mdl_multisizeinfo__heading">Eine andere Größe hinzufügen?</div>\n    <div class="mdl_multisizeinfo__content en_wysiwyg">Eine Größe (' +
((__t = ( alreadyAddedSizes.join(', ') )) == null ? '' : __t) +
') wurde bereits hinzugefügt. Sind Sie sich unsicher, welche Größe Sie brauchen? Probieren Sie doch einfach <strong>Fit Finder</strong> für eine persönliche Größenempfehlung aus.</div>\n</div>\n';

}
return __p
};
